export interface PushEventMessage {
  key: string;
  messageParams?: Record<string, unknown>;
}

export interface PushEvent {
  id: string;
  type: string;
  navigationLinkPathParams?: string[];
  navigationLinkQueryParams?: string[];
  message?: PushEventMessage;
  payload: Record<string, unknown>;
  timestamp: Date;
}

export enum PushEventType {
  TourplanPlanned = 'TourplanPlanned',
  TourplanUpdated = 'TourplanUpdated',
  ZekjuUpdated = 'ZekjuUpdated',
  ShipmentStatusRejectApprove = 'ShipmentStatusRejectApprove',
  ShipmentStatusChanged = 'ShipmentStatusChanged',
  ShipmentDeleted = 'ShipmentDeleted',
  ShipmentCreated = 'ShipmentCreated',
  LoadUpdated = 'LoadUpdated',
  LocationDataUpdated = 'LocationDataUpdated',
  CarrierUpdated = 'CarrierUpdated',
  CarrierDeleted = 'CarrierDeleted',
}

export type GetPushEventsParams = {
  type: string | string[];
  filter?: (event: PushEvent) => boolean;
};
